import React from 'react';
import {NonIdealState} from '@blueprintjs/core';

export const PleaseWait = () =>
  <NonIdealState
    icon="cube"
    title="Loading"
    description="Please wait"
  />;
